var render = function render(){var _vm=this,_c=_vm._self._c;return _c('home-project-card',{attrs:{"project":_vm.project,"badge":"Finalizada"}})
}
var staticRenderFns = []

export { render, staticRenderFns }